import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import Banner from "../../components/home/Banner";
import Event from "../../components/home/Event";
import About from "../../components/home/About";
import Service from "../../components/home/Service";
import Blog from "../../components/home/Blog";
import Contact from "../../components/home/Contact";
import Partners from "../../components/home/Partners";
import Branch from "../../components/home/Branch";
import Review from "../../components/home/Review";
import BranchContact from "../../components/home/BranchContact";

const Transform = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios.get("/api/blog").then((res) => {
      if (res.data.result === "0000") setData(res.data.data);
      else
        Swal.fire({
          title: "너무 많은 요청이 들어왔습니다. 다시 시도해주세요.",
          icon: "error",
        });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Banner />
      <BranchContact />
      <About />
      <Event />
      <Service />
      <Blog data={data} />
      <Branch />
      <Review />
      <Contact />
      <Partners />
    </div>
  );
};

export default Transform;
